module.exports = __webpack_public_path__ + "static/img/SkyCode.49fbc961.jpeg";